export default {
  computed: {
    pendingApproval() {
      return 1;
    },
    approved() {
      return 2;
    },
    rejected() {
      return 3;
    },
  },
};
